<template>
  <base-section
    id="service-features"
    :background="background"
    space="30"
  >
    <base-section-heading
      :title="$t('products.title')"
      :mobile-size="'text-h5'"
      :is_uppercase="false"
      :space="0"
    />
    <v-container
      class="pt-0"
    >
      <v-tabs
        v-model="tab"
        centered
        class="mb-4"
      >
        <v-tab
          v-for="(t, i) in tabs"
          :key="i"
          :value="i"
          class="text-capitalize"
        >
          {{ t }}
        </v-tab>
      </v-tabs>

      <v-row v-if="loading">
        <v-col
          cols="12"
          class="text-center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          />
          <p class="mt-4">
            {{ $t('common.loading') }}
          </p>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          v-for="card in filteredCards"
          :key="card.id"
          class="card-col"
          cols="12"
          sm="6"
          md="3"
        >
          <base-details-card
            class="card-box"
            aos-once
            data-aos="zoom-in"
            :data-aos-delay="card.delay"
            :show-text="true"
            :show-div-title="true"
            v-bind="card"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import productsData from '@/data/products.json'
  import { loadImage } from '@/utils/imageLoader'

  export default {
    name: 'ProductCenter',

    data: () => ({
      background: require('@/assets/bg-w-1.png'),
      cards: [],
      loading: true,
      tab: 0,
    }),

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.width <= 768
      },

      tabs() {
        return [
          this.$t('products.gallery.enterprise_products'),
          this.$t('products.gallery.hardware'),
        ]
      },

      filteredCards() {
        return this.cards.filter(card => {
          // tab索引对应关系：0=Drones (Drones), 1=Accessories (Hardware)
          const categoryMap = {
            0: 'Drones',
            1: 'Hardware',
          }
          const targetCategory = categoryMap[this.tab]

          return card.category === targetCategory
        })
      },
    },

    async mounted() {
      await this.loadCards()
    },

    methods: {
      async loadCards() {
        this.loading = true
        try {
          const cards = []
          for (const product of productsData.products) {
            // 过滤：只加载 showOnHome 为 true 的产品（默认 true）
            if (product.showOnHome !== false) {
              const imgUrl = await loadImage(product.imgUrl)
              cards.push({
                id: product.id,
                title: product.title,
                desc: product.desc,
                // subtitle: product.subtitle,
                callout: product.callout,
                imgUrl: imgUrl,
                background: product.background,
                to: product.clickable !== false ? product.route : null,
                delay: product.delay,
                category: product.category,
              })
            }
          }
          this.cards = cards
        } catch (error) {
          console.error('Failed to load cards:', error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
<style lang="sass" scoped>
::v-deep .v-container
  padding-top: 0 !important

::v-deep .base-section-heading
  margin-bottom: 0 !important
  .base-divider
    margin-bottom: 8px !important

.card-col
  // background: green
.card-box
  height: 100%
  // background: red
</style>
